<div
  (click)="closeDropdown()"
  class="bg-border-subtle fixed top-0 left-0 z-50 inline-flex w-full items-center justify-between gap-10 px-[24px] py-[8px] shadow-md">
  <a routerLink="/user" class="inline-flex flex-col items-center justify-start gap-[5px]">
    <h1
      class="logo-text textTabsColor text-3xl leading-none font-normal tracking-tight drop-shadow-lg"
      [ngClass]="{ 'logo-text-ar': currentLocale() == 'ar' }">
      {{ currentLocale() == "ar" ? "فارما" : "PIMS" }}
    </h1>
  </a>

  <div class="flex items-center justify-start gap-4">
    @if (userPharmacies().length > 0) {
      <div class="pharmacy-dropdown-container relative">
        <div
          (click)="togglePharmacyDropdown($event)"
          class="bgTabsColor flex cursor-pointer items-center gap-2 rounded-lg px-3 py-1.5 transition-opacity hover:opacity-90 ltr:mr-4 rtl:ml-4">
          <div class="flex flex-col ltr:text-left rtl:text-right">
            <span class="block max-w-[150px] truncate font-['Inter'] text-xs font-semibold text-white">
              @if (selectedPharmacy()) {
                {{ selectedPharmacy()?.nickName }}
              } @else {
                <span i18n="@@headerSelectPharmacy">Select Pharmacy</span>
              }
            </span>
            @if (selectedPharmacy()) {
              <span class="text-[10px] text-white/80">
                {{
                  currentLocale() === "ar"
                    ? (selectedPharmacy()?.region?.titleAr ? selectedPharmacy()?.region?.titleAr + " - " : "") +
                      (selectedPharmacy()?.city?.titleAr ?? "") +
                      (selectedPharmacy()?.governorate?.titleAr ? " - " + selectedPharmacy()?.governorate?.titleAr : "")
                    : (selectedPharmacy()?.region?.titleEn ? selectedPharmacy()?.region?.titleEn + " - " : "") +
                      (selectedPharmacy()?.city?.titleEn ?? "") +
                      (selectedPharmacy()?.governorate?.titleEn ? " - " + selectedPharmacy()?.governorate?.titleEn : "")
                }}
              </span>
            }
          </div>
          <svg
            [class.rotate-180]="isPharmacyDropdownOpen()"
            class="shrink-0 transition-transform duration-200"
            width="10"
            height="6"
            viewBox="0 0 10 6"
            fill="none">
            <path
              d="M1.28648 0.236001L8.71348 0.236001C8.95882 0.236001 9.15482 0.317335 9.30148 0.480001C9.44815 0.642001 9.52148 0.831335 9.52148 1.048C9.52148 1.116 9.51215 1.187 9.49348 1.261C9.47548 1.33433 9.44782 1.40467 9.41048 1.472L5.67748 7.315C5.59082 7.439 5.49148 7.53233 5.37948 7.595C5.26815 7.657 5.14182 7.688 5.00048 7.688C4.85915 7.688 4.73282 7.657 4.62148 7.595C4.51015 7.533 4.41082 7.43967 4.32348 7.315L0.590485 1.472C0.553818 1.40467 0.526151 1.33367 0.507484 1.259C0.488818 1.18433 0.479485 1.11333 0.479485 1.046C0.479485 0.828667 0.552817 0.639334 0.699484 0.477999C0.84615 0.316666 1.04182 0.236001 1.28648 0.236001Z"
              transform="translate(0 -0.236)"
              fill="white" />
          </svg>
        </div>
        @if (isPharmacyDropdownOpen()) {
          <div
            class="absolute top-12 z-50 max-h-64 w-max min-w-full overflow-y-auto rounded-lg border border-gray-200 bg-white shadow-xl ltr:right-0 rtl:left-0">
            @for (pharmacy of userPharmacies(); track pharmacy.id) {
              <button
                (click)="selectPharmacy(pharmacy)"
                class="group flex w-full items-center justify-between px-3 py-2 text-xs font-medium text-neutral-800 transition-colors hover:cursor-pointer hover:bg-gray-50 ltr:text-left rtl:text-right">
                <div class="flex flex-col">
                  <span class="block max-w-[150px] truncate">{{ pharmacy.nickName }}</span>
                  <span class="text-[10px] text-gray-500">
                    {{
                      currentLocale() === "ar"
                        ? (pharmacy.region?.titleAr ? pharmacy.region.titleAr + " - " : "") +
                          (pharmacy.city?.titleAr ?? "") +
                          (pharmacy.governorate?.titleAr ? " - " + pharmacy.governorate.titleAr : "")
                        : (pharmacy.region?.titleEn ? pharmacy.region.titleEn + " - " : "") +
                          (pharmacy.city?.titleEn ?? "") +
                          (pharmacy.governorate?.titleEn ? " - " + pharmacy.governorate.titleEn : "")
                    }}
                  </span>
                </div>
                @if (selectedPharmacy()?.id === pharmacy.id) {
                  <svg class="shrink-0 ltr:ml-3 rtl:mr-3" width="14" height="14" viewBox="0 0 16 16" fill="none">
                    <circle class="fill-primary" cx="8" cy="8" r="8" />
                    <path
                      d="M4.5 8L7 10.5L11.5 6"
                      stroke="white"
                      stroke-width="1.5"
                      stroke-linecap="round"
                      stroke-linejoin="round" />
                  </svg>
                }
              </button>
              @if (!$last) {
                <div class="border-t border-gray-200"></div>
              }
            }
          </div>
        }
      </div>
    }

    <button
      (click)="toggleLanguage()"
      class="borderTabsColor textTabsColor hover:borderTabsColor hover:bgTabsColor flex h-9 cursor-pointer items-center justify-center gap-2 rounded-lg border-2 bg-white px-4 py-2 transition-all hover:text-white active:scale-95">
      <svg class="h-4 w-4 transition-colors" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
        <path
          d="M12 22C17.5228 22 22 17.5228 22 12C22 6.47715 17.5228 2 12 2C6.47715 2 2 6.47715 2 12C2 17.5228 6.47715 22 12 22Z"
          stroke="currentColor"
          stroke-width="2"
          stroke-linecap="round"
          stroke-linejoin="round" />
        <path d="M2 12H22" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" />
        <path
          d="M12 2C14.5013 4.73835 15.9228 8.29203 16 12C15.9228 15.708 14.5013 19.2616 12 22C9.49872 19.2616 8.07725 15.708 8 12C8.07725 8.29203 9.49872 4.73835 12 2Z"
          stroke="currentColor"
          stroke-width="2"
          stroke-linecap="round"
          stroke-linejoin="round" />
      </svg>
      <span class="font-['Inter'] text-sm font-medium whitespace-nowrap transition-colors">
        {{ currentLocale() == "en" ? "العربية" : "English" }}
      </span>
    </button>

    <div class="notifications-container relative flex items-center justify-center gap-2">
      <div
        (click)="onNotificationsClick($event)"
        class="relative h-7 w-7 cursor-pointer overflow-hidden transition-transform hover:scale-110 active:scale-95">
        @if (!hasUnreadNotifications()) {
          <svg xmlns="http://www.w3.org/2000/svg" width="29" height="29" viewBox="0 0 24 24">
            <path
              class="fill-primary"
              d="M10 21h4c0 1.1-.9 2-2 2s-2-.9-2-2m11-2v1H3v-1l2-2v-6c0-3.1 2-5.8 5-6.7V4c0-1.1.9-2 2-2s2 .9 2 2v.3c3 .9 5 3.6 5 6.7v6zm-4-8c0-2.8-2.2-5-5-5s-5 2.2-5 5v7h10z" />
          </svg>
        } @else {
          <svg xmlns="http://www.w3.org/2000/svg" width="29" height="29" viewBox="0 0 24 24">
            <path
              class="fill-primary"
              d="M19 17v-5.2c-.5.1-1 .2-1.5.2H17v6H7v-7c0-2.8 2.2-5 5-5c.1-1.3.7-2.4 1.5-3.3c-.3-.4-.9-.7-1.5-.7c-1.1 0-2 .9-2 2v.3C7 5.2 5 7.9 5 11v6l-2 2v1h18v-1zm-9 4c0 1.1.9 2 2 2s2-.9 2-2zM21 6.5c0 1.9-1.6 3.5-3.5 3.5S14 8.4 14 6.5S15.6 3 17.5 3S21 4.6 21 6.5" />
          </svg>
        }
      </div>
      <app-notifications-dropdown [isOpen]="isNotificationsDropdownOpen()" (closeRequested)="onNotificationsClose()" />

      <div
        (click)="onCartClick()"
        class="textPrimaryColor relative cursor-pointer transition-transform hover:scale-110 active:scale-95">
        <!-- <app-cart-icon [quantity]="+cartData().totalQuantity" type="header" /> -->
        <app-cart-icon [quantity]="cartQuantity()" type="header" />
      </div>
    </div>

    <div class="relative" (click)="$event.stopPropagation()">
      <div
        (click)="toggleDropdown($event)"
        class="bgTabsColor hover-bg-primary-hover flex h-8 w-8 cursor-pointer items-center justify-center rounded-full font-['Inter'] text-sm font-semibold text-white transition-all active:scale-95">
        {{ userInitial() }}
      </div>

      @if (isDropdownOpen()) {
        <div
          class="absolute top-11 z-50 min-w-[175px] overflow-hidden rounded-lg border border-gray-200 bg-white shadow-xl ltr:right-0 rtl:left-0">
          <button
            (click)="onProfile()"
            class="hover:bgTabsColor w-full px-3 py-2 font-['Inter'] text-xs font-medium text-neutral-800 transition-colors hover:cursor-pointer hover:text-white ltr:text-left rtl:text-right">
            <span i18n="@@headerUpdateProfile">Profile</span>
          </button>
          <div class="border-t border-gray-200"></div>
          <button
            (click)="onLogout()"
            class="hover:bgTabsColor w-full px-3 py-2 font-['Inter'] text-xs font-medium text-neutral-800 transition-colors hover:cursor-pointer hover:text-white ltr:text-left rtl:text-right">
            <span i18n="@@headerLogout">Logout</span>
          </button>
        </div>
      }
    </div>
  </div>
</div>
